export default "__VITE_ASSET__9h0JBBpO__"